__turbopack_context__.v({
  "checkbox": "index-module__uNsDwG__checkbox",
});
